//REDUCER
import { RECIEVE_MODULE, RECIEVE_REVIEWS, ADD_REVIEW, RESET_LESSON } from '../actions'

const initialLessonState = {
	metadata: {},
	descriptions: {},
	objectives: {},
	contributors: {},
	addendums: {},
	reviews: [],
	mediaItems: {},
	quiz: null,
	preassessment: null,
	booster: null,
	content: {},
	content_validation: []
};

function module(
	state = {
		metadata: {},
		descriptions: {},
		objectives: {},
		contributors: {},
		addendums: {},
		reviews: [],
		mediaItems: {},
		quiz: null,
		preassessment: null,
		booster: null,
		content: {},
		//menu_validation: [],
		content_validation: []
	}, action) {
	switch (action.type) {
		case RECIEVE_MODULE:

			//var v = new Validator();
			/*
			let lessonMenu = { "units": action.json.content.units };


			var ajv = new Ajv(); // options can be passed, e.g. {allErrors: true}
			var validate = ajv.compile(menuSchema);
			validate(lessonMenu);
			console.log(action)
			*/

			return {
				metadata: action.json.metadata,
				descriptions: action.json.descriptions,
				objectives: action.json.objectives,
				contributors: action.json.contributors,
				addendums: action.json.addendums,
				reviews: action.json.reviews,
				mediaItems: action.json.mediaItems,
				quiz: action.json.quiz,
				preassessment: action.json.preassessment,
				booster: action.json.booster,
				content: action.json.content,
				//menu_validation: validate
			}
		case RESET_LESSON:
			return initialLessonState;
			
		case RECIEVE_REVIEWS:
			var newState = { ...state };

			newState.reviews = action.json.reviews

			return newState;

		case ADD_REVIEW:
			var newState = { ...state };

			newState.reviews = [
				...newState.reviews,
				{
					data: {
						id: action.id,
						uid: action.uid,
						stars: action.stars,
						review: action.review,
						experience: action.experience,
						showQuizzes: action.showQuizzes,
						date_changed: action.date_changed
					}
				}
			]

			return newState;


		default:
			return state
	}
}


export default module


export const getQuizTemplate = (module, quizType) => {
	if (quizType === "quiz") {
		if (module.quiz != null) {
			return module.quiz;
		}
	}

	if (quizType === "preassessment") {
		if (module.preassessment != null) {
			return module.preassessment;
		}
	}
	return null;
}